import { RadioButtonGroupInput } from 'react-admin';
import { Box, Typography } from '@mui/material';

interface Props {
    source: string;
    label: string;
    readOnly?: boolean;
}

const RadioButtonInputWithLabelOnTop = ({ source, label, readOnly = false }: Props) => (
    <Box
        sx={{
            display: 'grid',
            gap: 0.5,
            alignItems: 'center',
            '& fieldset': {
                m: 0,
                ml: 1,
            },
            '& fieldset label': {
                mr: 3,
            },
        }}
    >
        <Typography data-cy='label'>{label}</Typography>

        <RadioButtonGroupInput
            disabled={readOnly}
            label={false}
            helperText={false}
            source={source}
            choices={[
                { id: 'yes', name: 'Oui' },
                { id: 'no', name: 'Non' },
            ]}
        />
    </Box>
);

export default RadioButtonInputWithLabelOnTop;
